<template>
  <div class="container-fluid">
    <Breadcrumbs title="Alta De Usuarios" main="Alta De Usuarios" />
    <div class="card border-0 shadow-sm">
      <form class="card-body p-4" @submit.prevent="validarFormularioAlta">
        <div class="row g-3">
          <div class="col-12">
            <label class="form-label fw-semibold" for="nombre">Nombre</label>
            <input
              id="nombre"
              v-model="inputs.nombre.data"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': inputs.nombre.errorMessage, 'is-valid': formSubmitted && !inputs.nombre.errorMessage }"
              placeholder="Introduce el nombre del usuario"
              :disabled="disabled"
            />
            <div v-if="inputs.nombre.errorMessage" class="invalid-feedback d-block">
              {{ inputs.nombre.errorMessage }}
            </div>
          </div>
          <div class="col-12">
            <label class="form-label fw-semibold" for="correo">Correo electrónico</label>
            <input
              id="correo"
              v-model="inputs.correo.data"
              type="email"
              class="form-control"
              :class="{ 'is-invalid': inputs.correo.errorMessage, 'is-valid': formSubmitted && !inputs.correo.errorMessage }"
              placeholder="Introduce un correo electrónico"
              :disabled="disabled"
            />
            <div v-if="inputs.correo.errorMessage" class="invalid-feedback d-block">
              {{ inputs.correo.errorMessage }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold" for="contraseña">Contraseña</label>
            <div class="input-group">
              <input
                id="contraseña"
                v-model="inputs.contraseña.data"
                :type="typeContraseña"
                class="form-control"
                :class="{ 'is-invalid': inputs.contraseña.errorMessage, 'is-valid': formSubmitted && !inputs.contraseña.errorMessage }"
                placeholder="Introduce una contraseña"
                :disabled="disabled"
              />
              <button type="button" class="btn btn-outline-secondary" @click="mostrarContraseña">
                {{ typeContraseña === "password" ? "Mostrar" : "Ocultar" }}
              </button>
            </div>
            <div v-if="inputs.contraseña.errorMessage" class="invalid-feedback d-block">
              {{ inputs.contraseña.errorMessage }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold" for="repetirContraseña">Repetir contraseña</label>
            <div class="input-group">
              <input
                id="repetirContraseña"
                v-model="inputs.repetirContraseña.data"
                :type="typeRepetirContraseña"
                class="form-control"
                :class="{ 'is-invalid': inputs.repetirContraseña.errorMessage, 'is-valid': formSubmitted && !inputs.repetirContraseña.errorMessage }"
                placeholder="Repite la contraseña"
                :disabled="disabled"
              />
              <button type="button" class="btn btn-outline-secondary" @click="mostrarRepetirContraseña">
                {{ typeRepetirContraseña === "password" ? "Mostrar" : "Ocultar" }}
              </button>
            </div>
            <div v-if="inputs.repetirContraseña.errorMessage" class="invalid-feedback d-block">
              {{ inputs.repetirContraseña.errorMessage }}
            </div>
          </div>
          <div class="col-12">
            <label class="form-label fw-semibold" for="rol">Rol</label>
            <select
              id="rol"
              v-model="inputs.rol.data"
              class="form-select"
              :class="{ 'is-invalid': inputs.rol.errorMessage, 'is-valid': formSubmitted && !inputs.rol.errorMessage }"
              :disabled="disabled"
            >
              <option value="">Selecciona un rol</option>
              <option v-for="rol in rolesConsultados" :key="rol.id" :value="rol.id">
                {{ rol.name }}
              </option>
            </select>
            <div v-if="inputs.rol.errorMessage" class="invalid-feedback d-block">
              {{ inputs.rol.errorMessage }}
            </div>
          </div>
        </div>
        <div class="mt-4 d-flex justify-content-end gap-2">
          <button type="submit" class="btn btn-primary px-4" :disabled="disabled">
            Guardar
          </button>
          <button type="button" class="btn btn-light" :disabled="disabled" @click="resetearFormulario">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "AltaUsuarios",
  data() {
    return {
      inputs: {
        nombre: { data: "", errorMessage: "" },
        correo: { data: "", errorMessage: "" },
        contraseña: { data: "", errorMessage: "" },
        repetirContraseña: { data: "", errorMessage: "" },
        rol: { data: "", errorMessage: "" },
      },
      typeContraseña: "password",
      typeRepetirContraseña: "password",
      formSubmitted: false,
      disabled: false,
      rolesConsultados: [],
    };
  },
  computed: {
    ...mapState("autenticacion", ["roles"]),
  },
  watch: {
    roles: {
      handler(roles) {
        this.rolesConsultados = roles || [];
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    try {
      await this.consultarRoles();
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: e.msg || "No se pudieron cargar los roles.",
      });
    }
  },
  methods: {
    ...mapActions("autenticacion", ["registrarUsuario", "consultarRoles"]),
    mostrarContraseña() {
      this.typeContraseña = this.typeContraseña === "password" ? "text" : "password";
    },
    mostrarRepetirContraseña() {
      this.typeRepetirContraseña = this.typeRepetirContraseña === "password" ? "text" : "password";
    },
    resetearFormulario() {
      Object.keys(this.inputs).forEach((k) => {
        this.inputs[k].data = "";
        this.inputs[k].errorMessage = "";
      });
      this.formSubmitted = false;
    },
    validarFormularioAlta() {
      this.formSubmitted = true;
      const v = this.inputs;

      v.nombre.errorMessage = v.nombre.data.trim().length >= 2 ? "" : "Proporciona un nombre (mín. 2 caracteres)";
      v.correo.errorMessage = emailRegex.test(v.correo.data) ? "" : "Correo inválido";
      v.contraseña.errorMessage =
        !v.contraseña.data ? "Proporciona una contraseña" : v.contraseña.data.length < 6 ? "Contraseña mínimo 6 caracteres" : "";
      v.repetirContraseña.errorMessage =
        !v.repetirContraseña.data ? "Repite la contraseña" : v.contraseña.data !== v.repetirContraseña.data ? "Las contraseñas deben coincidir" : "";
      v.rol.errorMessage = v.rol.data ? "" : "Debes seleccionar un rol";

      const hasError = Object.values(v).some((x) => x.errorMessage);
      if (hasError) return;

      this.crearUsuario();
    },
    async crearUsuario() {
      this.disabled = true;
      try {
        await this.registrarUsuario({
          correo: this.inputs.correo.data,
          contraseña: this.inputs.contraseña.data,
          nombre: this.inputs.nombre.data,
          rol: this.inputs.rol.data,
        });

        await Swal.fire({
          icon: "success",
          title: "Usuario creado",
          text: "El usuario se registró correctamente.",
        });
        this.$router.push({ path: '/dashboard/consultar-usuarios', query: { correo: this.inputs.correo.data } });
      } catch (e) {
        Swal.fire({
          icon: e.msg ? "error" : "warning",
          title: e.code || "Error",
          text: e.msg || e.message || "No se pudo crear el usuario.",
        });
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
